module.exports = __webpack_public_path__ + "static/CosmicForces_HeaderVideo_v03-b9872d4a7dadede88adb63de77915244.mp4";